export default __webpack_public_path__ + "media/faq/faq_engraving_screenshot_1-8e9bf3b6.png";